<template>
  <div>
    <!-- <input type="text" id="text" value="百度语音合成" style="width: 500px;" />
    <span id="vBtn" @click="voicePlay">点击播放</span> -->
  </div>
</template>

<script>
var audio = null;
export default {
  props: ["voiceData"],
  mounted() {
    this.tts();
  },
  methods: {
    voicePlay() {
      console.log(this.voiceData);
      if (audio !== null) {
        this.$nextTick(() => {
          audio.play();
        });
      }
    },
    tts() {
      // let text = document.getElementById("text").value;
      let _this = this;
      let text = this.voiceData;
      // playBtn.innerText = "准备中";

      // 调用语音合成接口
      // 参数含义请参考 https://ai.baidu.com/docs#/TTS-API/41ac79a6
      audio = btts(
        {
          tex: text,
          tok:
            "25.736a02a94fa13b07f3557950ca34b375.315360000.1912672261.282335-21979455",
          spd: 5,
          pit: 5,
          vol: 15,
          per: 4,
        },
        {
          volume: 0.3,
          autoDestory: true,
          timeout: 10000,
          hidden: false,
          onInit: function (htmlAudioElement) {},
          onSuccess: function (htmlAudioElement) {
            audio = htmlAudioElement;
            document.getElementsByTagName("audio")[0].style.display = "none";
            _this.voicePlay();
          },
          onError: function (text) {
            alert(text);
          },
          onTimeout: function () {
            alert("timeout");
          },
        }
      );
    },
  },
};
</script>

<style>
#vBtn {
  position: fixed;
  z-index: 9999999999;
}
</style>